export default __webpack_public_path__ + "static/gs-python-code-01a15cd6b64cc9bbfc767bedf6a91514.png";